import React from "react";

// Elegant placeholder shown while a lazily code-split section chunk loads.
export function SectionSkeleton({ minHeight = 420 }) {
  return (
    <div
      className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20"
      style={{ minHeight }}
      aria-hidden="true"
    >
      <div className="mx-auto max-w-2xl text-center">
        <div className="mx-auto h-3 w-24 rounded-full bbm-skeleton" />
        <div className="mx-auto mt-4 h-8 w-2/3 rounded-lg bbm-skeleton" />
        <div className="mx-auto mt-4 h-3 w-1/2 rounded-full bbm-skeleton" />
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-48 rounded-2xl bbm-skeleton" />
        ))}
      </div>
    </div>
  );
}
